// ─────────────────────────────────────────────────────────────────────────────
// Override API client — talks to the Cloudflare API, which proxies to the Fly
// worker for time-sensitive daily overrides.
// ─────────────────────────────────────────────────────────────────────────────

const API_BASE = import.meta.env.VITE_API_URL || "/";
const API_TOKEN = import.meta.env.VITE_API_TOKEN || "";

export interface DailyOverride {
  date: string;
  wakeTimeOverride: string | null;
  cancelled: boolean;
  createdAt: string;
}

async function api(path: string, opts: RequestInit = {}) {
  const url = `${API_BASE}${path}`;
  const res = await fetch(url, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${API_TOKEN}`,
      ...opts.headers,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function fetchOverride(date: string): Promise<DailyOverride | null> {
  try {
    const { override } = await api(`/api/override?date=${encodeURIComponent(date)}`);
    return override;
  } catch {
    return null;
  }
}

export async function setOverride(opts: {
  date: string;
  wakeTimeOverride?: string | null;
  cancelled?: boolean;
}): Promise<DailyOverride> {
  const { override } = await api("/api/override", {
    method: "POST",
    body: JSON.stringify(opts),
  });
  return override;
}

export async function clearOverride(date: string): Promise<boolean> {
  const { removed } = await api(`/api/override?date=${encodeURIComponent(date)}`, {
    method: "DELETE",
  });
  return removed;
}
